import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { UserMenusService } from '../../shared/services/user-menus.service';

/**
 * Restringe el acceso a rutas del dashboard según los menús asignados al usuario.
 * Si la ruta no está permitida, redirige al inicio.
 */
export const menuAccessGuard: CanActivateFn = async (
  route,
): Promise<boolean | UrlTree> => {
  const userMenusService = inject(UserMenusService);
  const router = inject(Router);

  await userMenusService.loadMenus();

  const routePath = route.routeConfig?.path;
  if (!routePath) {
    return true;
  }

  if (userMenusService.canAccessRoute(routePath)) {
    return true;
  }

  return router.createUrlTree(['/home']);
};
